import React from 'react';
// import { focusElemnt } from '../helper';
import {t, U_NEED_TO_AGREE,TNC,AND,PRIVACY,AGREE,DONT_AGREE } from '../../../translations/Login';

const AlertTerms = ({ msg, error = false, success = false, close, className = '', setTncFLag }) => {
    return (
        <div className="alert" onClick={close}>
            <div
                className={`alert--content${error ? ' error' : ''}${success ? ' success' : ''} ${className}`}
                style={{ padding: 0 }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className='terms'
                    style=
                    {{
                        fontSize: '0.875em',
                        color: '#444',
                        lineHeight: '1.625em',
                        letterSpacing: '0.02rem',
                        padding: '24px'
                    }}>
                    {t(U_NEED_TO_AGREE)} <br />
                    <a href="/reservation_terms" target="_blank" style={{ color: 'var(--ksrtcThColor1)', textDecoration: 'underline' }}>{t(TNC)}</a> {/* {t(AND)} <a style={{ color: 'var(--ksrtcThColor1)', textDecoration: 'underline' }} href="#">{t(PRIVACY)}</a> */}
                </div>
                <div className='bottom-wrap' style={{ display: 'flex' }}>
                    <div style=
                        {{
                            width: '50%',
                            borderTop: '1px solid var(--ksrtcThColor2)',
                            color: 'var(--ksrtcThColor2)',
                            fontSize: '0.875em',
                            padding: '10px',
                            cursor: 'pointer',
                        }}
                        onClick={() => { close(); setTncFLag(false); }}
                    >{t(DONT_AGREE)}</div>
                    <div style={{
                        width: '50%',
                        background: 'var(--ksrtcThColor2)',
                        color: '#fff',
                        fontWeight: '600',
                        fontSize: '0.875em',
                        padding: '10px',
                        borderRadius: '0 0 6px 0',
                        cursor: 'pointer'
                    }}
                        onClick={() => { close(); setTncFLag(true); }}

                    >{t(AGREE)}</div>
                </div>
            </div>
        </div >
    )
}

export default AlertTerms